import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-paciente-home-image',
    templateUrl: './paciente-home-image.component.html',
    styleUrls: ['./paciente-home-image.component.scss'],
    standalone: false
})
export class PacienteHomeImageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
